import { render, staticRenderFns } from "./optional_page.vue?vue&type=template&id=5c60e049&scoped=true"
import script from "./optional_page.vue?vue&type=script&lang=js"
export * from "./optional_page.vue?vue&type=script&lang=js"
import style0 from "./optional_page.vue?vue&type=style&index=0&id=5c60e049&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60e049",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c60e049')) {
      api.createRecord('5c60e049', component.options)
    } else {
      api.reload('5c60e049', component.options)
    }
    module.hot.accept("./optional_page.vue?vue&type=template&id=5c60e049&scoped=true", function () {
      api.rerender('5c60e049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/views/process_map/components/business_context/form/optional_page.vue"
export default component.exports